import { SafePipe } from './pipes/safevideo.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { MaterialModule } from '../other-modules/matmodules/material.module';
import { ShowMovieComponent } from './dialogs/show-movie/show-movie.component';
import { TranslateModule } from '@ngx-translate/core';
import { QuestionModalComponent } from './dialogs/question-modal/question-modal.component';
import { ImageModalComponent } from './dialogs/image-modal/image-modal.component';
import { QuestionCompleteModalComponent } from './dialogs/question-complete-modal/question-complete-modal.component';
import { AllQuestionModalComponent } from './dialogs/all-question-modal/all-question-modal.component';
import { SignupComponent } from './dialogs/signup/signup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IntroModalComponent } from './dialogs/intro-modal/intro-modal.component';
import { LoginComponent } from './dialogs/login/login.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectInputComponent } from './custom-components/select-input/select-input.component';
import { DifficultyLevelComponent } from './dialogs/difficulty-level/difficulty-level.component';
import { SnackbarComponent } from './dialogs/snackbar/snackbar.component';
import { ConfirmationComponent } from './dialogs/confirmation/confirmation.component';
import { LevelContinueComponent } from './dialogs/level-continue/level-continue.component';
import { ShowQrComponent } from './dialogs/show-qr/show-qr.component';
import { TeamConfigComponent } from './dialogs/team-config/team-config.component';
import { GameSettingsComponent } from '../features/component/game-settings/game-settings.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { DoubleClick } from '../shared/services/doubleclick.directive';
import { MaxTwoCharactersDirective } from '../shared/services//max.directive';
import { LogoutComponent } from './dialogs/logout/logout.component';




@NgModule({
  declarations: [
    LoaderComponent, 
    ShowMovieComponent,
    SafePipe,
    QuestionModalComponent,
    ImageModalComponent, 
    QuestionCompleteModalComponent, 
    AllQuestionModalComponent, 
    SignupComponent, 
    IntroModalComponent, 
    LoginComponent, 
    SelectInputComponent, 
    DifficultyLevelComponent , 
    SnackbarComponent, 
    ConfirmationComponent, 
    LevelContinueComponent, 
    ShowQrComponent, 
    GameSettingsComponent,
    TeamConfigComponent,
    LogoutComponent,
    DoubleClick,
    MaxTwoCharactersDirective
  ],

  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgxQRCodeModule
  ],

  exports:[
    LoaderComponent,
    SelectInputComponent,
    SnackbarComponent,
    GameSettingsComponent,
    DoubleClick,
    MaxTwoCharactersDirective
  ],


})
export class SharedModule { }
